<template>
  <div v-if="showDebug" class="debug-panel">
    <div class="debug-content">
      <h3>Debug Panel</h3>
      <p>If the app is not loading properly, try these options:</p>
      
      <div class="debug-actions">
        <Button
          @click="clearAuth"
          variant="default"
          size="sm"
          class="debug-btn-warning"
        >
          Clear Auth Data
        </Button>
        <Button
          @click="clearAll"
          variant="destructive"
          size="sm"
        >
          Clear All Data
        </Button>
        <Button
          @click="reload"
          variant="default"
          size="sm"
          class="debug-btn-primary"
        >
          Reload Page
        </Button>
      </div>

      <div class="debug-info">
        <h4>Storage Info:</h4>
        <pre>{{ storageInfo }}</pre>
      </div>

      <Button
        @click="closeDebug"
        variant="secondary"
        size="sm"
        class="debug-close-btn"
      >
        Close
      </Button>
    </div>
  </div>
</template>

<script>
import { Button } from '@/components/ui/button'
import { clearAuthStorage, clearAllStorage, getStorageInfo } from '@/utils/storage'

export default {
  name: 'DebugPanel',
  components: {
    Button
  },
  data() {
    return {
      showDebug: false,
      storageInfo: {}
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    handleKeydown(event) {
      if (event.ctrlKey && event.shiftKey && event.key === 'D') {
        this.toggleDebug()
      }
    },
    toggleDebug() {
      this.showDebug = !this.showDebug
      if (this.showDebug) {
        this.updateStorageInfo()
      }
    },
    updateStorageInfo() {
      this.storageInfo = getStorageInfo()
    },
    clearAuth() {
      if (clearAuthStorage()) {
        alert('Auth data cleared. Reloading page...')
        window.location.reload()
      } else {
        alert('Failed to clear auth data')
      }
    },
    clearAll() {
      if (confirm('This will clear ALL data. Are you sure?')) {
        if (clearAllStorage()) {
          alert('All data cleared. Reloading page...')
          window.location.reload()
        } else {
          alert('Failed to clear data')
        }
      }
    },
    reload() {
      window.location.reload()
    },
    closeDebug() {
      this.showDebug = false
    }
  }
}
</script>

<style scoped>
.debug-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.debug-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.debug-actions {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
  flex-wrap: wrap;
}

.debug-info {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
  margin: 1rem 0;
}

.debug-info pre {
  margin: 0;
  font-size: 0.875rem;
  white-space: pre-wrap;
}

.debug-btn-warning {
  background: #f59e0b;
  color: white;
}

.debug-btn-warning:hover {
  background: #d97706;
}

.debug-btn-primary {
  background: #3b82f6;
  color: white;
}

.debug-btn-primary:hover {
  background: #2563eb;
}

.debug-close-btn {
  margin-top: 1rem;
  width: 100%;
}
</style>

